import { useClient } from "../context";

export function useAccount() {
  const client = useClient()

  return {
    account: client.data?.account,
    status: client.status
  }
}